var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6426 5C18.9444 5 20 6.05561 20 7.35742V18.3574C19.9998 19.6591 18.9443 20.7139 17.6426 20.7139H11.3574C10.0557 20.7139 9.00015 19.6591 9 18.3574V13.5713C11.9127 12.5415 14 9.76532 14 6.5C14 5.98628 13.948 5.48469 13.8496 5H17.6426ZM19.2139 8.53125C17.0236 6.30455 13.7141 7.387 13.7139 10.5869C13.7139 13.7781 19.1826 17.2604 19.2139 17.2803V8.53125ZM6.5 0C8.22391 0 9.87769 0.684334 11.0967 1.90332C12.3157 3.12231 13 4.77609 13 6.5C13 10.0899 10.0899 13 6.5 13C2.91015 13 0 10.0899 0 6.5C0 2.91015 2.91015 0 6.5 0ZM6.5 3.63965C6.10512 3.63965 5.78516 3.96059 5.78516 4.35547V5.78516H4.35547C3.96059 5.78516 3.63965 6.10512 3.63965 6.5C3.63965 6.89488 3.96059 7.21484 4.35547 7.21484H5.78516V8.64453C5.78516 9.03941 6.10512 9.36035 6.5 9.36035C6.89488 9.36035 7.21484 9.03941 7.21484 8.64453V7.21484H8.64453C9.03941 7.21484 9.36035 6.89488 9.36035 6.5C9.36035 6.10512 9.03941 5.78516 8.64453 5.78516H7.21484V4.35547C7.21484 3.96059 6.89488 3.63965 6.5 3.63965Z",
    fill: "#1AAADC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1766_1818",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6426 5C18.9444 5 20 6.05561 20 7.35742V18.3574C19.9998 19.6591 18.9443 20.7139 17.6426 20.7139H11.3574C10.0557 20.7139 9.00015 19.6591 9 18.3574V13.5713C11.9127 12.5415 14 9.76532 14 6.5C14 5.98628 13.948 5.48469 13.8496 5H17.6426ZM19.2139 8.53125C17.0236 6.30455 13.7141 7.387 13.7139 10.5869C13.7139 13.7781 19.1826 17.2604 19.2139 17.2803V8.53125ZM6.5 0C8.22391 0 9.87769 0.684334 11.0967 1.90332C12.3157 3.12231 13 4.77609 13 6.5C13 10.0899 10.0899 13 6.5 13C2.91015 13 0 10.0899 0 6.5C0 2.91015 2.91015 0 6.5 0ZM6.5 3.63965C6.10512 3.63965 5.78516 3.96059 5.78516 4.35547V5.78516H4.35547C3.96059 5.78516 3.63965 6.10512 3.63965 6.5C3.63965 6.89488 3.96059 7.21484 4.35547 7.21484H5.78516V8.64453C5.78516 9.03941 6.10512 9.36035 6.5 9.36035C6.89488 9.36035 7.21484 9.03941 7.21484 8.64453V7.21484H8.64453C9.03941 7.21484 9.36035 6.89488 9.36035 6.5C9.36035 6.10512 9.03941 5.78516 8.64453 5.78516H7.21484V4.35547C7.21484 3.96059 6.89488 3.63965 6.5 3.63965Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1766_1818)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-2 -2)",
    fill: "#1AAADC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 24,
    height: 24,
    fill: "#1AAADC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCard);
export default __webpack_public_path__ + "static/media/plus-card.6ec957ee596180dce349eaf9a42c5ad1.svg";
export { ForwardRef as ReactComponent };